<template>
  <div class="approve-preview-page">
    <h1 class="bigshot">{{ $t('W2P_REVIEW_PAGE') }}</h1>
    <router-view></router-view>
    <pn-toast
      icon="alert-exclamation-circle"
      appearance="warning"
      v-if="getResultWarnings.length"
    >
      <p
        v-html="
          $t('W2P_REVIEW_PAGE_PDF_WARNING', {
            url: '#/letter/upload/preview-letter'
          })
        "
      ></p>
    </pn-toast>

    <transition name="fade" mode="out-in">
      <div class="preview-wrapper">
        <PreviewMaterialComponent
          :controls="['pagination']"
          @loading="handleLoading"
        ></PreviewMaterialComponent>
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <TableComponent></TableComponent>
    </transition>

    <div class="button-container">
      <pn-button-container secondary size="medium">
        <button @click="$router.push({ name: 'delivery' })">
          {{ $t('W2P_LETTER_BACK') }}
        </button>
      </pn-button-container>

      <pn-button-container size="medium">
        <button @click="$router.push({ name: 'contactInformation' })">
          {{ $t('NEXT') }}
        </button>
      </pn-button-container>
    </div>
  </div>
</template>

<script>
import TableComponent from '@/components/letter/pay/preview/TableComponent.vue'
import PreviewMaterialComponent from '@/components/PreviewMaterialComponent.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    TableComponent,
    PreviewMaterialComponent
  },
  computed: {
    ...mapGetters('letter/upload', ['getResultWarnings'])
  },
  methods: {
    handleLoading(e) {
      this.loadingPreview = e
    }
  }
}
</script>

<style lang="scss" scoped>
pn-toast {
  margin-top: 1.5em;
}

.approve-preview-page {
  padding: 3em 4em;

  .preview-wrapper {
    margin: 0 auto;
    margin-bottom: 2em;
    width: 60%;
  }
}

@media screen and (max-width: 50em) {
  .approve-preview-page {
    padding: 0 !important;
    .preview-wrapper {
      width: 100%;
      margin: 0;
      margin-bottom: 2em;
      padding: 0;
    }
  }
}
</style>
